export const STATE_NAME = 'experiments';
export const USER_IDENTIFIER_COOKIE_NAME = 'ha_anonymous_id';

export enum ActionTypes {
  SET_VARIANTS = 'EXPERIMENTS/SET_VARIANTS',
  PLAY_EXPERIMENT = 'EXPERIMENTS/PLAY_EXPERIMENT',
}
